// eslint-disable-next-line import/prefer-default-export
export function prefetchAssets(assets) {
  assets.forEach(asset => {
    const img = new Image();
    img.src = asset;
  });
}
